import { useIntl } from 'react-intl';
import type { RatingStarsProps } from '@packages/shared/src/ui/Rating/RatingStars';
import { RatingStars } from '@packages/shared/src/ui/Rating/RatingStars';
import { ratingIconsWithReviewCountMessages } from './RatingIconsWithReviewCount.messages';
import { maximumRatingAmount } from '../config';
import { RatingsCount } from '../RatingsCount/RatingsCount';

export type RatingIconsWithReviewCountProps = RatingStarsProps & {
  ratingsCount: number;
  isLinked?: boolean;
};

/**
 * Shows Rating Icons and the amount of given ratings
 * */
export const RatingIconsWithReviewCount = ({
  ratingValue,
  ratingsCount,
  isLinked = false,
  ...props
}: RatingIconsWithReviewCountProps) => {
  const { formatMessage } = useIntl();

  const ariaLabelText = formatMessage(
    ratingValue && ratingsCount
      ? ratingIconsWithReviewCountMessages.ariaLabel
      : ratingIconsWithReviewCountMessages.ariaLabelZero,
    { ratingValue: ratingValue?.toFixed(2), maxRating: maximumRatingAmount, ratingsCount },
  );

  return (
    <div className="flex flex-row items-center gap-1" aria-label={ariaLabelText} {...props}>
      <RatingStars ratingValue={ratingValue} />
      {ratingsCount > 0 && (
        <RatingsCount ratingsCount={ratingsCount} isLinked={isLinked} type="icons" />
      )}
    </div>
  );
};
